const SMS_TEMPLATE_ID_KEY = 'smsTemplateId';

/**
 * The SMS template set chosen by staff when they send a patient booking link
 * arrives as a `?smsTemplateId=` query parameter and has to survive the
 * multi-step booking wizard, so it is parked in localStorage.
 *
 * It is stored per workflow. A template picked for one booking link must never
 * be applied to a different appointment the patient books later, which is what
 * happened while a single global key was used and the link was opened but the
 * booking abandoned.
 */
const buildKey = (workflowId) => `${SMS_TEMPLATE_ID_KEY}:${workflowId}`;

export const saveSmsTemplateId = (workflowId, smsTemplateId) => {
  if (!workflowId || !smsTemplateId) {
    return;
  }

  window.localStorage.setItem(buildKey(workflowId), smsTemplateId);
};

export const getSmsTemplateId = (workflowId) => {
  if (!workflowId) {
    return null;
  }

  return window.localStorage.getItem(buildKey(workflowId));
};

export const clearSmsTemplateId = (workflowId) => {
  if (!workflowId) {
    return;
  }

  window.localStorage.removeItem(buildKey(workflowId));
};

/**
 * Drops the pre-scoping global key so a template id already sitting in a
 * patient's browser stops being applied to whatever they book next.
 */
export const removeLegacySmsTemplateId = () =>
  window.localStorage.removeItem(SMS_TEMPLATE_ID_KEY);
